import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export interface EtfEyebrowProps {
  children: ReactNode;
  className?: string;
}

/**
 * Section eyebrow — small orange uppercase label preceded by a short
 * horizontal rule. Used as a kicker above section headings throughout
 * the marketing site.
 */
export function EtfEyebrow({ children, className }: EtfEyebrowProps) {
  return (
    <div
      className={cn(
        "font-[family-name:var(--font-instrument)] text-xs tracking-[0.2em] uppercase text-[var(--etf-orange)] flex items-center gap-3 mb-[18px]",
        "before:content-[''] before:inline-block before:w-6 before:h-px before:bg-[var(--etf-orange)]",
        className,
      )}
    >
      {children}
    </div>
  );
}
